<template>
  <div class="cc-wrap">
    <label class="form-label">CC <em style="font-weight:400; font-size:11px; color:#9ca3af; letter-spacing:0">— opsional, jika tidak perlu cc orang lain tidak perlu diisi</em></label>

    <!-- Tags + input row -->
    <div class="cc-field" :class="{ 'cc-field--focus': focused }" @click="focusInput">
      <span v-for="user in selectedUsers" :key="user.id" class="cc-tag">
        {{ user.name }}
        <button type="button" class="cc-tag-remove" @click.stop="remove(user.id)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-3 h-3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </span>
      <input
        ref="input"
        v-model="query"
        type="text"
        class="cc-input"
        placeholder="Cari nama..."
        autocomplete="off"
        @focus="focused = true; showDrop = true"
        @blur="onBlur"
        @keydown.backspace="onBackspace"
        @keydown.escape="showDrop = false"
      />
    </div>

    <!-- Dropdown suggestions -->
    <div v-if="showDrop && filtered.length" class="cc-drop">
      <button
        v-for="user in filtered"
        :key="user.id"
        type="button"
        class="cc-drop-item"
        @mousedown.prevent="select(user)"
      >
        <div class="cc-drop-avatar">{{ user.name[0] }}</div>
        <div class="cc-drop-info">
          <span class="cc-drop-name">{{ user.name }}</span>
          <span class="cc-drop-email">{{ user.email }}</span>
        </div>
      </button>
    </div>

    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: { type: Array, default: () => [] }, // array of user IDs
    availableUsers: { type: Array, default: () => [] }, // [{ id, name, email }]
    error: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      query: '',
      focused: false,
      showDrop: false,
    }
  },
  computed: {
    selectedUsers() {
      return this.availableUsers.filter(u => this.modelValue.includes(u.id))
    },
    filtered() {
      const q = this.query.toLowerCase().trim()
      return this.availableUsers.filter(u =>
        !this.modelValue.includes(u.id) &&
        (u.name.toLowerCase().includes(q) || u.email.toLowerCase().includes(q))
      ).slice(0, 8)
    },
  },
  methods: {
    focusInput() {
      this.$refs.input?.focus()
    },
    select(user) {
      this.$emit('update:modelValue', [...this.modelValue, user.id])
      this.query = ''
      this.showDrop = true
      this.$nextTick(() => this.$refs.input?.focus())
    },
    remove(id) {
      this.$emit('update:modelValue', this.modelValue.filter(v => v !== id))
    },
    onBackspace() {
      if (this.query === '' && this.modelValue.length) {
        this.$emit('update:modelValue', this.modelValue.slice(0, -1))
      }
    },
    onBlur() {
      setTimeout(() => {
        this.focused = false
        this.showDrop = false
        this.query = ''
      }, 150)
    },
  },
}
</script>

<style scoped>
.cc-wrap { position: relative; }

.cc-field {
  display: flex; flex-wrap: wrap; align-items: center; gap: 5px;
  min-height: 2.6rem; padding: 5px 10px;
  background: #fff; border: 1.5px solid #e2e8f0; border-radius: 10px;
  cursor: text; transition: border-color 0.15s, box-shadow 0.15s;
}
.cc-field--focus {
  border-color: #15803d;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(21, 128, 61, 0.12);
}

.cc-tag {
  display: inline-flex; align-items: center; gap: 4px;
  background: #f0fdf4; border: 1px solid #bbf7d0; color: #15803d;
  padding: 2px 8px 2px 10px; border-radius: 999px;
  font-size: 12px; font-weight: 500; white-space: nowrap;
}
.cc-tag-remove {
  display: flex; align-items: center; justify-content: center;
  width: 14px; height: 14px; border-radius: 50%;
  background: rgba(21,128,61,0.12); color: #15803d;
  border: none; cursor: pointer; padding: 0; line-height: 1;
  transition: background 0.12s;
}
.cc-tag-remove:hover { background: rgba(21,128,61,0.25); }

.cc-input {
  flex: 1; min-width: 100px; border: none; outline: none;
  background: transparent; font-size: 14px; color: #1e293b;
  padding: 2px 0;
}
.cc-input::placeholder { color: #94a3b8; }

/* Dropdown */
.cc-drop {
  position: absolute; left: 0; right: 0; top: calc(100% + 4px);
  z-index: 200; background: #fff; border: 1px solid #e2e8f0;
  border-radius: 12px; box-shadow: 0 8px 24px rgba(0,0,0,0.1);
  overflow: hidden; max-height: 240px; overflow-y: auto;
}
.cc-drop-item {
  display: flex; align-items: center; gap: 10px;
  width: 100%; padding: 8px 12px; border: none; background: none;
  text-align: left; cursor: pointer; transition: background 0.1s;
}
.cc-drop-item:hover { background: #f0fdf4; }
.cc-drop-avatar {
  width: 30px; height: 30px; border-radius: 50%; flex-shrink: 0;
  background: linear-gradient(135deg, #15803d, #166534);
  color: #fff; font-size: 13px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
}
.cc-drop-info { display: flex; flex-direction: column; min-width: 0; }
.cc-drop-name { font-size: 13px; font-weight: 600; color: #1e293b; }
.cc-drop-email { font-size: 11px; color: #6b7280; }

</style>

<style>
/* Dark mode — unscoped so .dark on .layout-app ancestor is matched */
.dark .cc-field {
  background: #1e1e1e; border-color: #3a3a3a; color: #e2e8f0;
}
.dark .cc-field--focus {
  border-color: #4ade80; background: #242424;
  box-shadow: 0 0 0 3px rgba(74,222,128,0.12);
}
.dark .cc-tag {
  background: rgba(21,128,61,0.15); border-color: #166534; color: #4ade80;
}
.dark .cc-input { color: #e2e8f0; }
.dark .cc-drop {
  background: #1e1e1e; border-color: #2a2a2a;
  box-shadow: 0 8px 24px rgba(0,0,0,0.4);
}
.dark .cc-drop-item:hover { background: rgba(74,222,128,0.08); }
.dark .cc-drop-name { color: #f1f5f9; }
.dark .cc-drop-email { color: #6b7280; }
</style>
